import {
  Component,
  OnInit,
  ViewChild,
  Output,
  ElementRef,
  EventEmitter,
  AfterViewInit,
  Input,
} from "@angular/core";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { ChatLogService } from "../../../services/chatlog.service";
import { LogManifestService } from "../../../services/logmanifest.service";
import { TicketsService } from "../../../services/tickets.service";
import { ProcessingpService } from "../../../services/processing.service";

import { ChatLog } from "../../../models/chatLog";
import { Methods } from "../../methods";

@Component({
  selector: "app-comments",
  templateUrl: "./comments.component.html",
  styleUrls: ["./comments.component.css"],
  providers: [ChatLogService, LogManifestService, ProcessingpService],
})
export class CommentsComponent implements OnInit {
  @Input() disabled = false;

  public mtds: Methods = new Methods();
  myWebSocket: WebSocketSubject<any> = webSocket(
    "wss://www.greenteksolutions.com/myws"
  );
  public numberNotifications;
  public notificationsData;
  public chats: Array<ChatLog> = [];
  public identity;
  public token;
  public loading2 = false;
  public saving = false;

  public newchatmsg;
  public jsonChatLog;
  public loading;
  public idChat;
  public itemChat;
  public groupArray;
  public showEdit = false;
  public mouseOvered = false;
  public hideEdit = false;
  public messageEdit = "";
  public historialArray = [];
  public viewsArray = [];
  public show = false;
  public isEdit = true;
  @Input() id_phather;
  @Input() type_chat;
  @Input() type_notification;
  @Input() is_Chatlog: boolean = true;
  @Input() item;
  @Input() views;
  @Input() message;

  public height: number;

  @Output("receive_item_id") sendMessageEvent: EventEmitter<string> =
    new EventEmitter<string>();

  @Output("total_chats") sendTotalChats: EventEmitter<string> =
    new EventEmitter<string>();

  @Output("saving_comment") sendSavingComment: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() taggedUserData = new EventEmitter<any>();
  constructor(
    private _chatLogService: ChatLogService,
    private _logManifestService: LogManifestService,
    private _ticketsService: TicketsService,
    private _processingSerice: ProcessingpService
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.token = JSON.parse(localStorage.getItem("token"));
  }

  ngOnInit() {
    this.getChat();
    console.log("comments", this.message);
    if (this.message) {
      this.sendMessage(this.message);
    }
  }
  ngOnChanges() {
    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'someInput'**************/
    //Write your code here
    this.getChat();
    this.getHeight();
  }

  getHeight(){
    if(this.type_chat === 'CONTAINERINVENTORY')
      this.height = 300;
    else
      this.height = 400;
  }

  get service() {
    return this.is_Chatlog == true
      ? this._chatLogService
      : this._logManifestService;
  }

  changeStyle($event, chat, i) {
    // console.log($event, chat, i);
    this.mouseOvered = true;
  }

  getChat() {
    this.loading = true;
    this.jsonChatLog = {
      type: this.type_chat,
    };
    if (this.type_chat === 'PAYMENT') {
      
      this._chatLogService
        .viewMessagepayment(this.token, this.id_phather, this.jsonChatLog)
        .subscribe(
          response => {
            if (response.status === 'success') {
              this.chats = response.data;
              this.sendTotalChats.emit(response.total_items_count);
              this.groupChatsFromDate(this.chats);
            }
            this.loading = false;
          },
          err => {
            console.error(err);
            this.loading = false;
          }
        );
      return; 
    }
    if (this.is_Chatlog == true) {
      this._chatLogService
        .getChat(this.token, this.id_phather, this.jsonChatLog)
        .subscribe(
          (response) => {
            if (response.status === "success") {

              if(this.type_chat === 'chatbug' && this.dataTagsN.type !== 'get' ){ // ? Steep 2
                this.dataTagsN.otherUsersChat = this.extractTaggedUserIdsFromConversation(response);
                this.processTaggedUsers();
              }
              
              this.chats = response.data;
              this.sendTotalChats.emit(response.total_items_count);

              if (this.chats) {
                // this gives an object with dates as keys
                this.groupChatsFromDate(this.chats);
              }
              this.loading = false;
            }
          },
          (error) => {
            console.log(<any>error);
          }
        );
    } else {
      this._logManifestService.getChat(this.token, this.id_phather).subscribe(
        (response) => {
          if (response.status === "success") {
            this.chats = response.data;

            if (this.chats) {
              // this gives an object with dates as keys
              this.groupChatsFromDate(this.chats);
            }
            this.loading = false;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    }
  }

  dataTagsN = {
    type: 'get',
    message: undefined,
    taggedUserIds: [],
    messageOld: undefined,
    oldTaggedUserOldsIds: [],
    otherUsersChat: []
  }
  oldMessage: string;
// ? Steep 1
  getChatBug(type?: string, message?: string, messageOld?: string) {
    this.dataTagsN.type = type;
    this.dataTagsN.message = message;

    if(type === 'edit') {
      this.dataTagsN.messageOld = messageOld;
    }
    this.getChat()
  }

// ? Steep 3
  extractTaggedUserIdsFromConversation(conversation) {
    const userIds = new Set();
    conversation.data.forEach(message => {
        const taggedUsers = message.message.match(/@[\w_]+_(\d+)/g);
        if (taggedUsers) {
            taggedUsers.forEach(tag => {
                const userId = Number(tag.split('_').pop());
                userIds.add(userId);
            });
        }
    });
    return Array.from(userIds);
  }

  // ? Steep 4
  processTaggedUsers(): void {
    const extractUserIds = (msg: string) => {
      const regex = /@[\w]+_(\d+)/g;
      return Array.from(new Set([...msg.matchAll(regex)].map(match => parseInt(match[1], 10)).filter(id => !isNaN(id))));
    };
    this.dataTagsN.taggedUserIds = extractUserIds(this.dataTagsN.message);
    this.dataTagsN.oldTaggedUserOldsIds = this.dataTagsN.type === 'edit' && this.dataTagsN.messageOld ? extractUserIds(this.dataTagsN.messageOld) : undefined;
    this.taggedUserData.emit(this.dataTagsN);
  }

  groupChatsFromDate(chats) {
    const groups = chats.reduce((groups, chat) => {
      let completeDate = this.mtds.getFecha(
        new Date(chat.createdAt.timestamp * 1000),
        "MM/dd/yyyy h:mm:ss"
      );
      let datetime = completeDate.split(" ");
      let hour = datetime[1];
      let date = datetime[0];

      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(chat);
      return groups;
    }, {});

    const groupArrays = Object.keys(groups).map((date) => {
      return {
        date,
        chats: groups[date],
      };
    });
    this.groupArray = groupArrays;
  }

  hour(date) {
    let datetime = date.split(" ");
    let hour = datetime[1];
    let time = datetime[2];

    return `${hour} ${time}`;
  }
  date(date) {
    let dateTime = date.split(" ");
    let hour = dateTime[1];
    let fullDate = dateTime[0];
    let dateSplitted = fullDate.split("-");
    let year;
    let month;
    let day;
    year = dateSplitted[0];
    month = dateSplitted[1];
    day = dateSplitted[2];

    return `${month}-${day}-${year} ${hour}`;
  }
  getChatDates() {
    this.chats.map;
  }
  deleteChat(id) {
    this.idChat = id;

    if (confirm("Are you sure you want to delete this chat?")) {
      this.saving = true;
      this.service.remove(this.token, this.idChat).subscribe(
        (response) => {
          if (response.status != "success") {
            if (response.longmsg) {
              this.mtds.notifyError(response.msg, response.longmsg);
            } else {
              this.mtds.notifyError(response.msg);
            }
          } else {
            this.mtds.notifySuccess("The chat has been removed successfully");
            if(response.data.type === 'chatbug'){
              this.getChatBug('remove', response.data.message);
            }else{
              this.getChat();
            }
          }
          this.saving = false;
        },
        (error) => {
          console.log(<any>error);
          this.saving = false;
          this.mtds.notifyError("error");
        }
      );
    }
  }

  editMsg(message: string, id) {
    console.log(message);
    this.isEdit = true;
    message = message.trim();
    if (message.length > 0) {
      this.newchatmsg = message;
      console.log("EDIT FIRED", this.newchatmsg);
      this.saveEdit(id);
    }
  }

  editChat(id, msg) {
    this.showEdit = true;
    this.idChat = id;
    this.oldMessage = msg;
    this.messageEdit = msg;
  }
  cancelEdit() {
    this.showEdit = false;
    this.idChat = null;
  }
  hideChat() {
    this.historialArray = [];
    this.hideEdit = false;
  }
  hideViews() {
    this.viewsArray = [];
    this.show = false;
  }
  showHistory(historial, id) {
    this.idChat = id;
    this.historialArray = JSON.parse(historial);
    this.hideEdit = true;
    console.log("show", this.historialArray);
  }
  showViews(views, id) {
    this.idChat = id;
    this.show = true;
    this.viewsArray = JSON.parse(views);
    console.log("show", this.viewsArray);
  }
  saveEdit(id) {
    // https://greenteksolutionsllc.com/backend/crm/web/logmanifest/edit/{chat_id}
    // {"message":"Prueba 4", "pi_id":"1854"}
    let json;

    if (!this.isEdit) {
      if (this.is_Chatlog) {
        json = {
          message: this.messageEdit,
          father_id: this.id_phather,
          type: this.type_chat,
        };
      } else {
        json = {
          message: this.messageEdit,
          pi_id: this.id_phather,
        };
      }
    }
    if (this.isEdit) {
      if (this.is_Chatlog) {
        json = {
          message: this.newchatmsg,
          father_id: this.id_phather,
          type: this.type_chat,
        };
      } else {
        json = { message: this.newchatmsg, pi_id: this.id_phather };
      }
    }    
    this.service.edit(this.token, json, id).subscribe(
      (response) => {
        if (response.status != "success") {
          this.myWebSocket.next({
            notify: "1",
            data: this.id_phather,
            type: "EDIT-LOG",
            token: this.token,
            action: "UPDATE", // NEW ó UPDATE ó DELETE
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          this.myWebSocket.next({
            notify: "1",
            data: this.id_phather,
            type: "NOTETAGGED",
            token: this.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
            toDestiny: "USERS",
            toData: this.newchatmsg,
            element: this.item.po.id,
            texto: this.item.po.name,
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );
        } else {
          this.mtds.notifySuccess("The chat has been edited successfully");
          if(response.data.type === 'chatbug'){
            this.getChatBug('edit', response.data.message, this.oldMessage);
          }else{
            this.getChat();
          }
        }
        this.saving = false;
        this.cancelEdit();
      },
      (error) => {
        console.log(<any>error);
        this.saving = false;
        this.mtds.notifyError("error");
      }
    );
  }

  sendMessage(message: string) {
    console.log("sendMessage fired up", this.item);

    message = message.trim();
    if (message.length > 0) {
      this.newchatmsg = message;

      if (this.type_chat == "BATCH" && this.id_phather === null) {
        this.create_batch();
      } else if (this.type_chat == "chatbug") {
        this.sendMsgBack();
      } else if (this.id_phather === null) {
        this.getItemId();
      } else {
        this.sendChat();
      }
    }
  }


  sendMsgBack(){
    this.sendMessageEvent.emit(this.id_phather);
    this.sendChat();
  }

  create_batch() {
    this.saving = true;
    this.disabled = true;
    this.sendSavingComment.emit(true);
    let data_send: any;
    data_send = {
      ssd: this.item.ssd,
      hardDrives: this.item.hardDrives,
      laptops: this.item.laptops,
      processing_instruction_id: this.item.processing_instruction_id,
      allInOne: this.item.allInOne,
      desktops: this.item.desktops,
      internallocation_id: this.item.newcontainerInternallocation_id,
      newcontainerTotalNetWeight: this.item.newcontainerTotalNetWeight,
      status: "Pending",
      weight: this.item.newcontainerWeight,
      caddies: this.item.caddies,
      newContentType: this.item.newContentType,
      newContainerType: this.item.newContainerType,
    };

    this._processingSerice.newItemManifest(this.token, data_send).subscribe(
      (r) => {
        if (r.status === "success") {
          this.id_phather = r.data.id;

          this.sendMessageEvent.emit(this.id_phather);
          this.sendChat();
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.saving = false;
        this.disabled = false;
        this.sendSavingComment.emit(false);
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.saving = false;
        this.disabled = false;
      }
    );
  }

  getItemId() {
    this.saving = true;
    this.disabled = true;
    this.sendSavingComment.emit(true);
    this._ticketsService.createWeight(this.item).subscribe(
      (r) => {
        console.log("createWeight => ", r);
        if (r.status === "success") {
          this.id_phather = r.data.id;
          console.log("this.id_phather => ", this.id_phather);
          this.sendMessageEvent.emit(this.id_phather);
          this.sendChat();
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.saving = false;
        this.disabled = false;
        this.sendSavingComment.emit(false);
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.saving = false;
        this.disabled = false;
        this.sendSavingComment.emit(false);
      }
    );
  }

  sendChat() {
    let me = this;

    this.loading2 = true;
    this.disabled = true;
    this.sendSavingComment.emit(true);

    let enviar;

    if (this.is_Chatlog == true) {
      enviar = {
        message: this.newchatmsg,
        father_id: this.id_phather,
        type: this.type_chat,
      };
    } else if (this.is_Chatlog == false) {
      enviar = {
        message: this.newchatmsg,
        pi_id: this.id_phather,
      };
    }

    this.service.create(this.token, enviar).subscribe(
      (response) => {
        me.loading2 = false;
        me.disabled = false;
        me.sendSavingComment.emit(false);
        if (response.status === "success") {
          me.chats.push(response.data);
          if(response.data.type === 'chatbug'){
            this.getChatBug('create', response.data.message);
          }else{
            this.getChat();
          }
          me.myWebSocket.next({
            notify: "1",
            data: me.id_phather,
            type: me.type_notification,
            token: me.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
          });

          me.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              me.numberNotifications = msg.numberNotifications;
              me.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          me.myWebSocket.next({
            notify: "1",
            data: me.id_phather,
            type: me.type_chat,
            token: me.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
            toDestiny: "USERS",
            toData: me.newchatmsg,
            element: me.id_phather,
            texto: me.id_phather,
          });

          me.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              me.numberNotifications = msg.numberNotifications;
              me.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          me.newchatmsg = "";
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
}
